<script>
import ValueComboBox from './ValueComboBox'

export default {
  name: 'SpecialAdCategoriesComboBox',
  components: {
    ValueComboBox
  },
  computed: {
    items() {
      return [
        { value: 'CREDIT', text: 'Credit Opportunity' },
        { value: 'EMPLOYMENT', text: 'Employment Opportunity' },
        { value: 'HOUSING', text: 'Housing Opportunity or Related Service' },
        { value: 'ISSUES_ELECTIONS_POLITICS', text: 'Social Issues, Elections or Politics' },
        { value: 'NONE', text: 'None' }
      ]
    }
  }
}
</script>

<template>
  <value-combo-box
    multiple
    @input="$emit('input', $event)"
    :items="items"
    label="Special ad categories"
    v-bind="$attrs"
  />
</template>
